import { ShoppingBag } from 'lucide-react'

interface OrderPlacedProps {
  interactionData: any
}

export function OrderPlaced({ interactionData }: OrderPlacedProps) {
  const productItems = interactionData.product_items || []
  const totalItems = productItems.reduce((sum: number, item: any) => sum + parseInt(item.quantity || 0), 0)
  const totalValue = productItems.reduce((sum: number, item: any) => {
    const quantity = parseInt(item.quantity || 0)
    const price = parseFloat(item.item_price || 0)
    return sum + (quantity * price)
  }, 0)
  const currency = productItems[0]?.currency || 'USD'

  return (
    <div
      className="max-w-sm"
      style={{ fontFamily: 'var(--wn-font)' }}
    >
      <div className="flex items-center gap-2.5 pb-2.5 border-b border-[#edf1f7]">
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <ShoppingBag className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="truncate"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}
          >
            Order Placed
          </div>
          <div
            className="truncate mt-0.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
          >
            {totalItems} items • {productItems.length} products
          </div>
        </div>
      </div>

      {productItems.length > 0 && (
        <div className="mt-2.5 space-y-1.5">
          <div
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 600, color: '#6a7282', textTransform: 'uppercase', letterSpacing: '0.04em' }}
          >
            Order Details
          </div>
          <div
            className="rounded-[10px] p-2.5 space-y-1.5"
            style={{ background: '#fbfcfd', border: '1px solid #edf1f7' }}
          >
            {productItems.map((item: any, index: number) => {
              const quantity = parseInt(item.quantity || 0)
              const price = parseFloat(item.item_price || 0)
              const itemTotal = quantity * price
              const productName = item.product_name || `Product ${item.product_retailer_id}`

              return (
                <div
                  key={index}
                  className="flex justify-between items-start gap-2 pb-1.5 border-b border-[#edf1f7] last:border-b-0 last:pb-0"
                >
                  <div className="flex-1 min-w-0">
                    <div
                      className="truncate"
                      style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 600, color: '#101828' }}
                    >
                      {productName}
                    </div>
                    <div
                      style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
                    >
                      {quantity} × {currency} {price.toFixed(2)}
                    </div>
                    {item.product_retailer_id && (
                      <div
                        className="truncate"
                        style={{ fontFamily: 'var(--wn-font)', fontSize: 10, fontWeight: 500, color: '#9ca3af' }}
                      >
                        ID: {item.product_retailer_id}
                      </div>
                    )}
                  </div>
                  <div
                    className="shrink-0"
                    style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 700, color: '#101828' }}
                  >
                    {currency} {itemTotal.toFixed(2)}
                  </div>
                </div>
              )
            })}

            <div className="flex justify-between items-center pt-2 mt-1 border-t border-[#edf1f7]">
              <div style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}>
                Total
              </div>
              <div style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#1EB677' }}>
                {currency} {totalValue.toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      )}

      {interactionData.order_text && (
        <div
          className="mt-2.5 rounded-[10px] p-2.5"
          style={{ background: '#E8F8F0' }}
        >
          <div
            className="mb-1"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 700, color: '#0F8A55' }}
          >
            Special Instructions
          </div>
          <div style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 500, color: '#0F8A55' }}>
            "{interactionData.order_text}"
          </div>
        </div>
      )}
    </div>
  )
}
